const BASE_STORAGE = 'https://static.insta360.com/assets/storage';
const BASE_OPERATION = 'https://static.insta360.com/assets/operation';
const BASE_ICON = 'https://static.insta360.com/assets/www/project/store/icon';
export const IMG = {
  Cart: {
    oldEmpty: BASE_OPERATION + '/0190/5fea608547c41bb9f73a6e2d5013f71a/ic_cart_empty@2x.png',
    empty: 'https://res.insta360.com/static/29e012bb7b257e7e7beff4bff9448fd4/illustration_cart-alert.png',
    paymentCN:
      'https://res.insta360.com/static/assets/storage/20201105/c6130137ba008f3d05d9012a92c85dec/ic_cart_payment_zh_2x.png',
    paymentOS: BASE_OPERATION + '/0190/760661ae93203729e5018d833a0bc81d/ic_cart_payment_en@2x.png',
    countMinus: BASE_OPERATION + '/0190/4204796bb8fb58c77c6698f550786415/ic_cart_less_h@2x.png',
    countPlus: BASE_OPERATION + '/0190/df5123e7e847df93614d0cc79aaeeb3d/ic_cart_plus_h@2x.png',
  },
  Order: {
    ifree: BASE_STORAGE + '/20190615/8d4e4ffea54fabd9acf40038df480138/free@2x.png',
    iCouponTheme: BASE_STORAGE + '/20190615/9bdda4e5a4f8b06d6b697d6cb29c2323/ic_coupon@2x.png',
    orderIcPC: BASE_STORAGE + '/20190615/4f3224c8433dbd13432a8a2a3c0549ef/ic_order_n@2x.png',
    orderIcMB: BASE_STORAGE + '/20190615/546cf961a2981ebf61b089a6983978b7/ic_order_n_mb@2x.png',
    iTrack: BASE_STORAGE + '/20181221/30cfbadee81a6c0762345d7b974f36ac/i-order.png',
    iResult: BASE_STORAGE + '/20190615/e83e1d15bf76f2920e2e2ef45a4a0ef2/ic_order@2x.png',
    resultSuccess: 'https://res.insta360.com/static/8ded62fefbacfb12b5e3a8b4b8b72edb/Frame%20626873960.png',
    iResultProcess:
      'https://res.insta360.com/static/b5efe83de7ecbc8f1328a2594d5ad9a2/%E7%AD%89%E5%BE%85%E8%BF%87%E7%A8%8B%20(1).png',
  },
  Reseller: {
    apply: {
      bg: BASE_STORAGE + '/20190615/8ad6f6d7fe63cf26253b80de870547ff/reseller_index_bg.png',
      evo: BASE_STORAGE + '/20190615/257906e785edaba3d75ed3a786a248b8/evo.png',
      onex: BASE_STORAGE + '/20190615/5dfb6e4328f33e36bfcaa89b42a076c0/onex.jpeg',
      one: BASE_STORAGE + '/20190615/9deac087017597808d3af94918488630/one@2x.png',
      pro2: BASE_STORAGE + '/20190615/7366b3423166bd17e1ad2ab82e07f442/pro2.jpeg',
      pro: BASE_STORAGE + '/20190615/95ef98e92f8488b88c5cc11758b7d274/pro@2x.png',
      nanos: BASE_STORAGE + '/20190615/8b623a1267c57849465bf3f42bc94e02/nanos@2x.png',
      nano: BASE_STORAGE + '/20190615/9f37d61110edad20581d6b52473ac1d1/nano@2x.png',
      air: BASE_STORAGE + '/20190615/8e0afe1823c554be9e8c1452ff04504f/air@2x.png',
      i_plus: BASE_STORAGE + '/20190615/4bf020994e54349790deaa86a2611681/i_plus.png',
      i_minus: BASE_STORAGE + '/20190615/f285797011277915ad62a82a4b57f4ff/i_minus.png',
      distributorFail: BASE_OPERATION + '/0184/9c275c6bf2090ca9440058cea70c36d6/ic_distributor_fail@2x.png',
      distributorTimeout: BASE_OPERATION + '/0184/51bb0be20e339402923f0e75d3ee54c3/resaler_ic_timeout@2x.png',
      distributorReview: BASE_OPERATION + '/0054/2915e24ca34c83215ae8457ec4fe489a/ic_distributor_review@2x.png',
      distributorPass: BASE_OPERATION + '/0184/de3aace5944a7b0b284a89e2a43f418b/ic_distributor_pass@2x.png',
    },
    income: {
      helpBlack: BASE_STORAGE + '/20190615/eca252124be8eebfad6c1471ba68ce67/ic_help_h@2x.png',
      helpGray: BASE_STORAGE + '/20190615/665d3b9d32be622dad632aaa5efb0688/ic_help_n@2x.png',
    },
    withdraw: {
      rightGray: BASE_STORAGE + '/20190216/29bb79e0cd62dd37df6aa63f7d05bd77/i-right.png',
      help: BASE_OPERATION + '/0184/3c469f71ad0aa788be1f2b91b5a1f513/ic_resaller_help@2x.png',
      stateChoose: 'https://res.insta360.com/static/5744957a4c0a34ccafbc762742bcf9f9/icon%20(1)%204.svg',
      datepicker: 'https://res.insta360.com/static/3cb02d5cb9756fd0073678e05ef4dcc9/icon%20(1)%203.svg',
    },
    affiliate: {
      eye: BASE_STORAGE + '/20190221/fadc87af961de84bd2a5f02c88d84e8f/eye-icon.png',
    },
  },
  Tradeup: {
    i0: BASE_STORAGE + '/20200427/3d6f1c3a53a7a1e9ec5f58bb52af0a51/1.png',
    i1: BASE_STORAGE + '/20200427/f25b9d98dddd235939384bd3c5fc1b2d/2.png',
    i2: BASE_STORAGE + '/20200427/4b4a0ab86b48c465fc8e53cbbcb43645/3.png',
    i3: BASE_STORAGE + '/20200427/e1011352c9435a961bf1072934c86333/4.png',
  },
};

export const ICON = {
  iDownWhite: BASE_ICON + '/i_down_white.png',
  iPlayWhite: BASE_ICON + '/i_play_white.png',
  logo: BASE_OPERATION + '/0184/a363dd8e58846609a00292df6fccf4db/ic_insta360store_pc@2x.png',
  menuMB: BASE_OPERATION + '/0184/48f0c236ec85594e899bb3a5a60680bc/icon-menu_black@2x.png',
  cartGray: BASE_STORAGE + '/20190615/4a28d82a56b9dc2cbfdba3e5e226ed30/ic_cart@2x.png',
  userGray: BASE_STORAGE + '/20190615/a582a32d5437fa25694735f1a49fc880/ic_user@2x.png',
  userGrayXmas: BASE_STORAGE + '/20191212/aaa00982991809049ff0aac70c7cd02e/xmas_(1).png',
  closeBlack: BASE_STORAGE + '/20190615/d24ecc4133d4889f1fb1f6603c999315/i_close.png',
  arrowLeftBlack: BASE_STORAGE + '/20190615/d6cb5651ec1bd3601f275813798c74d4/i_back.png',
  arrowRightBlack: BASE_STORAGE + '/20190615/d6263209ac57b5324aba7d3b277e77e3/i_more.png',
  plusGray: BASE_STORAGE + '/20190615/368bdd7ed6919b8ab0a2c21c6c6f5003/i_open.png',
  checkBoxDefault: BASE_STORAGE + '/20190615/6d1d30c4ecaa69024d1df5f612738121/checkbox_default.png',
  checkBoxActived: BASE_STORAGE + '/20190615/2dc5ebe7d1a4576553a079959b122d27/checkbox_actived.png',
  progressDefault: `https://res.insta360.com/static/cd429f75b24604131096786b8b657253/0.png`,
  progressActived: `https://res.insta360.com/static/e3ba2ec48e91f93af78bfcaa584f4406/1.png`,
  progressFinish: `https://res.insta360.com/static/7a3047363ad96f7a7568617920d8586b/2.png`,
  cartPlus: BASE_OPERATION + '/0190/df5123e7e847df93614d0cc79aaeeb3d/ic_cart_plus_h@2x.png',
  cartMinus: BASE_OPERATION + '/0190/4204796bb8fb58c77c6698f550786415/ic_cart_less_h@2x.png',
  playVideoGray: BASE_STORAGE + '/20190615/902599901c81974d1eba7f8eff177c27/buy_ic_videos_play@2x.png',
  user: BASE_OPERATION + '/0184/3bafa3a80b9599b095e7c091e2ceb78b/header_ic_account_a@2x.png',
  deleteGray: BASE_STORAGE + '/20190615/a15dee0a87c7d55a2700bcbac937f336/ic_delete@2x.png',
  editGray: BASE_STORAGE + '/20190615/b19b6e167ee35d9185a9e1cc8ee9bddf/ic_edit@2x.png',
  leftGray: BASE_STORAGE + '/20190615/19b61d16a1093620073feb85d076af9d/ic_left@2x.png',
  rightGray: BASE_STORAGE + '/20190615/4261ec7cee8a699cd246cfe257d83cec/ic_right@2x.png',
  upGray: BASE_STORAGE + '/20190615/9348e5402e547a8ccd5663a32a17f2fd/ic_up@2x.png',
  downGray: BASE_STORAGE + '/20190615/d916e0794cad43b54db72093b5fdf30a/ic_down@2x.png',
  areaGray: BASE_STORAGE + '/20190615/894e2ec7c04482c8e899c319c5991608/ic_gps@2x.png',
  newTheme: BASE_STORAGE + '/20190615/3577dc79258fce946004bdc9cd077ee9/ic_new@2x.png',
  emailGray: BASE_STORAGE + '/20190615/5fb14669fbf34915db28c4c1b5b330a5/email@2x.png',
  pwdGray: BASE_STORAGE + '/20190615/37b89b00ca350da52e6d2165d9bb5425/password@2x.png',
  repwdGray: BASE_STORAGE + '/20190615/86c75ebec8ad2d6b9798d228c1d38fc8/repassword@2x.png',
  noteTheme: BASE_STORAGE + '/20190426/cf334b1492e0b9a0a310ed351da56e80/note.png',
  addSolidBlack: BASE_OPERATION + '/0184/670847a52db7ccdd07077eb0b806dd87/ic_resaller_increase@2x.png',
  cloudService: 'https://res.insta360.com/static/ba2e7f50ebba74b2c12c424e5d9002b9/cloud.svg',
  cloudServiceTag: 'https://res.insta360.com/static/f4cb8bc8a6199d1bd9f1e78b549b73c1/blue.svg',
  cloudServiceTagWhite: 'https://res.insta360.com/static/85b8adb8bb04906f412ba6827d34a9cc/whiteIcon.svg',
  disableCloudService: 'https://res.insta360.com/static/00b52cf0e3873f0f5b803f278afb792d/Union.svg',
  defaultAvatar: 'https://static.insta360.com/assets/www/project/official/account/avatar_2.png',
  formEdit: 'https://res.insta360.com/static/b022c12f37a2362c0d0908c873afd0e9/Frame%20(4).svg',
  close: 'https://res.insta360.com/static/672b6ac343d7ca5f9d1318c1eaa00873/Frame%201973771450.svg',

  iLeftBlack72: BASE_ICON + '/i-left-black-72%402x.png',
  iRightBlack72: BASE_ICON + '/i-right-black-72%402x.png',
  iCloseGray48: BASE_ICON + '/i-close-gray-48%402x.png',

  social: {
    facebook: BASE_STORAGE + '/20190615/98d5b51054366f18d0849a091e7be4be/facebook.png',
    facebookGray: BASE_STORAGE + '/20190114/a6bd0c572e4c5393523cd1b21fc55dc7/ic_fb@2x.png',
    facebookColor: BASE_STORAGE + '/20190114/f8446df58698da3f19e8757cdad11b42/ic_fb_color.png',
    twitter: BASE_STORAGE + '/20190615/9de43159cb60a55ce245a1228e01c9fc/twitter.png',
    twitterGray: BASE_STORAGE + '/20190114/f5b1a6e803209e437aed03dd6f27b3ca/ic_tw@2x.png',
    twitterColor: BASE_STORAGE + '/20190114/f08bc4894aa660c0feae866a88f48872/ic_tw_color.png',
    line: BASE_STORAGE + '/20190615/693b5e63994ce488db685a2bdcec76ad/line.png',
    messenger: BASE_STORAGE + '/20190615/0195191260294608bd9b62a28a49f917/messenger.png',
    qq: BASE_STORAGE + '/20190615/69ba701925ec248c307bc55a9cb708ea/qq.png',
    qqzone: BASE_STORAGE + '/20190615/2ded38b3a901b80fe1bca79b2c986a53/qqZone.png',
    wechat: BASE_STORAGE + '/20190615/b95385d7710a6cf5fbc1f254b69a0ff5/wechat.png',
    wechatGray: BASE_STORAGE + '/20190114/fd834d54982f888d1d857850f61215dc/ic_wechat@2x.png',
    wechatColor: BASE_STORAGE + '/20190114/98f454ac209c532f999855e6b4a3413c/ic_wc_color.png',
    wechatMoment: BASE_STORAGE + '/20190615/86a2e949d5f28ea00a394907195a12be/wechatMoment.png',
    weibo: BASE_STORAGE + '/20190615/14b7a24a27a8375d9a5ea66f6d93c490/weibo.png',
    weiboGray: BASE_STORAGE + '/20190114/89da36a2342f4a9b43dc7309ed198d1d/ic_weibo@2x.png',
    weiboColor: BASE_STORAGE + '/20190114/e154604191691447aa180cab4bfbe6dd/ic_wb_color.png',
    whatsapp: BASE_STORAGE + '/20190615/04d46d14a8e26992dc543ee8602d7bfd/whatsapp.png',
  },
  footerSocail: {
    wechatQRCode: {
      '/product/real_estate_kit':
        'https://res.insta360.com/static/d7782c627bd057406fdc3d61a94440d9/QRCode-with-logo.png',
      '/enterprise': 'https://res.insta360.com/static/d7782c627bd057406fdc3d61a94440d9/QRCode-with-logo.png',
      '/product/8k_live': 'https://res.insta360.com/static/d7782c627bd057406fdc3d61a94440d9/QRCode-with-logo.png',
      default: 'https://res.insta360.com/static/82e46f6c6f0c256174be96dd5b6c2f92/deafult-QRCode-with-logo.png',
    },
  },
  orderPageSellingpoints: {
    securePayment: 'https://res.insta360.com/static/1babf0547b3d399e34d53e82fc0b9cb3/payment.svg',
    priceGuarantee: 'https://res.insta360.com/static/f033d7e27c28446ce7e1a0550945f6fe/7day.svg',
    warranty: 'https://res.insta360.com/static/9713fac63cdbeaf20e5984e2db2abb1f/return.svg',
  },
};

export const deleteSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 33' fill='none'>
    <g>
      <path
        d='M26.7044 5.36353C27.2567 5.36353 27.7044 5.81374 27.7044 6.36911C27.7044 6.92447 27.2567 7.37469 26.7044 7.37469H5.41552C4.86324 7.37469 4.41553 6.92447 4.41553 6.36911C4.41553 5.81374 4.86324 5.36353 5.41552 5.36353H26.7044Z'
        fill='currentColor'
      />
      <path
        d='M19.3635 3.35107C19.9158 3.35107 20.3635 3.80129 20.3635 4.35666C20.3635 4.91202 19.9158 5.36224 19.3635 5.36224H12.6929C12.1406 5.36224 11.6929 4.91202 11.6929 4.35666C11.6929 3.80129 12.1406 3.35107 12.6929 3.35107H19.3635Z'
        fill='currentColor'
      />
      <path
        d='M7.67209 11.3969C7.67209 10.8415 8.1223 10.3913 8.67767 10.3913H23.3219C23.8773 10.3913 24.3275 10.8415 24.3275 11.3969V24.1343C24.3275 25.8004 22.9769 27.151 21.3108 27.151H10.6888C9.02273 27.151 7.67209 25.8004 7.67209 24.1343V11.3969Z'
        stroke='currentColor'
        strokeWidth='2.01116'
      />
      <path
        d='M13.6743 14.1667C14.2266 14.1667 14.6743 14.617 14.6743 15.1723V22.7978C14.6743 23.3532 14.2266 23.8034 13.6743 23.8034C13.122 23.8034 12.6743 23.3532 12.6743 22.7978V15.1723C12.6743 14.617 13.122 14.1667 13.6743 14.1667Z'
        fill='currentColor'
      />
      <path
        d='M18.375 14.1667C18.9273 14.1667 19.375 14.617 19.375 15.1723V22.7978C19.375 23.3532 18.9273 23.8034 18.375 23.8034C17.8227 23.8034 17.375 23.3532 17.375 22.7978V15.1723C17.375 14.617 17.8227 14.1667 18.375 14.1667Z'
        fill='currentColor'
      />
    </g>
  </svg>
);

export const AFFILIATE_MODAL_IMG = {
  bg: BASE_STORAGE + '/20190513/ab769f0b13dad857aeda27aabc2ca951/desktop-bg@2x.png',
  invisibleSelfieStick: BASE_STORAGE + '/20191212/9bd8b5cd4183112f53dcc0d0032f6288/Invisible_Selfie_Stick.png',
  goCarryCase: BASE_STORAGE + '/20200415/11fdd2e9f61e4fc74819ef1a21a1f381/goC.png',
  proBattery: BASE_STORAGE + '/20190513/34afd2149395f252643313335be94fe4/battery.png',
  charginStation: BASE_STORAGE + '/20190513/d5c800583e87c9725f29e1526fcbc1d8/charging_station.png',
  coldWeatherBattery: BASE_STORAGE + '/20190513/65240092700684bc70aa2fa0233e12f2/cold_weather_battery.png',
  ONERBattrry: BASE_STORAGE + '/20200603/bb31cb86e66a87c17916cb183669ee44/1.png',
  lensCap: BASE_STORAGE + '/20191212/e53fede1acf7199fddd94ae9f50d0f33/LensCap.png',
};
